import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import DesktopTurtil from "./components/DesktopSecurityCheck";
import User from "./components/admin";
import Navbar from "./components/Nav";
import Home from "./components/Home";
import About from "./components/About";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import ContactForm from "./components/ContactForm";
import BackToTop from "./components/BackToTop";
import ScrollTopButton from "./components/ScrollTopButton";
import AnimatedCursor from "./components/AnimatedCursor";
import Footer from "./components/Footer";
import Youtubechan from "./components/youtubechannel";
import Blog from "./components/blog";
import { getHome } from "./components/api/homeService";
import BlogDetails from "./components/BlogDetails";
// Scroll to section component
function ScrollToSection() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location]);

  return null;
}

// Main layout component
function MainLayout({ theme, toggleTheme, home }) {
  // const isUser =
  //   window.location.hostname === "user.localhost" ||
  //   window.location.hostname === "user.syncpulsesignal.com" ;

  // if (isUser) {
  //   return <User />;
  // }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className={`app ${theme}`}
    >
      <ScrollToSection />
      <AnimatedCursor theme={theme} />
      <Navbar theme={theme} toggleTheme={toggleTheme} />

      <div id="home">
        <Home home={home} />
      </div>

      <div id="about">
        <About home={home} />
      </div>

      <div id="experience">
        <Experience home={home} />
      </div>

      <div id="projects">
        <Projects home={home} />
      </div>

      <div id="contact">
        <ContactForm home={home} />
      </div>

      <div id="youtubechannel">
        <Youtubechan home={home} />
      </div>

      <Footer home={home} />
      <BackToTop />
    </motion.div>
  );
}
function RouteScrollButton() {
  const location = useLocation();

  const isMainPage = location.pathname === "/";

  if (isMainPage) {
    return null;
  }

  return <ScrollTopButton />;
}
function App() {
  const [theme, setTheme] = useState("dark");

  const [home, setHome] = useState(null);
  const [homeLoading, setHomeLoading] = useState(true);

  const [loading, setLoading] = useState(
    window.location.pathname === "/" &&
    !sessionStorage.getItem("skipPreloader")
  );

  const toggleTheme = () => {
    setTheme((prevTheme) =>
      prevTheme === "dark" ? "light" : "dark"
    );

    document.body.classList.toggle("light-theme");
  };

  // Load Home data FIRST
  useEffect(() => {
    const loadHome = async () => {
      try {
        const res = await getHome();

        const raw = res?.data?.data ?? res?.data ?? null;

        // API may return object or array
        const homeData = Array.isArray(raw) ? raw[0] : raw;

        console.log("HOME DATA:", homeData);
        console.log("FOOTER LOGO:", homeData?.footerLogo);

        setHome(homeData || null);
      } catch (error) {
        console.error("Failed to load Home data:", error);
        setHome(null);
      } finally {
        setHomeLoading(false);
      }
    };

    loadHome();
  }, []);

  // Existing preloader
  useEffect(() => {
    if (window.location.pathname !== "/") return;

    if (sessionStorage.getItem("skipPreloader")) {
      sessionStorage.removeItem("skipPreloader");
      return;
    }

    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  // ------------------------------------------------
  // FULL SCREEN LOADING
  // ------------------------------------------------
  if (!home || loading) {
    return (
      <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-[#0C121D]">
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-indigo-500/30 blur-xl" />

          <div className="relative h-14 w-14 animate-spin rounded-full border-[6px] border-slate-700 border-t-indigo-500" />
        </div>
      </div>
    );
  }
  return (
    <DesktopTurtil>
      <Router>
        <ScrollToSection />
        <AnimatedCursor theme={theme} />
        <Routes>
          <Route path="/user" element={<User />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route
            path="/"
            element={
              <MainLayout
                theme={theme}
                toggleTheme={toggleTheme}
                home={home}
              />
            }
          />
        </Routes>
        <RouteScrollButton />
      </Router>
    </DesktopTurtil>
  );
}

export default App;